<template>
	<div class="page flex-col">
		<div class="box_1 flex-col">
			<div class="group_1 flex-col">
				<div style="display: flex;justify-content: flex-end;">
					<!-- <img @click="kefu_to" class="label_1" referrerpolicy="no-referrer"
						src="@/assets/icon/icon_kf.png" /> -->
				</div>
				<div class="block_2 flex-col">
					<div class="text_1">五行商会登录</div>
					<div class="text-wrapper_1 flex-col">
						<input v-model.trim="data.username" type="text" class="text_2" placeholder="请输入手机号码">
					</div>
					<div class="section_1 flex-row justify-between">
						<input v-model.trim="data.password" :type="password" class="text_3"
							:placeholder="$t('login.password')">
						<span class="eye_bi" style="display:inline-block;vertical-align: sub;"
							:class="password == 'text' ? 'eye' : ''" @click="showPwd"></span>
					</div>
					<div class="item_reset_pwd">
						<van-checkbox v-model="checked" shape="square" icon-size="14px">
							{{ $t('login.remember') }}
						</van-checkbox>
						<div class="reset_pwd" @click.stop="kefu_to">
							{{ $t('login.forget') }}?
						</div>
					</div>
					<div type="submit" class="basic_btn sbtn"
						:class="data.username == '' || data.password == '' ? 'no_touch' : '' " @click="submit">
						{{ $t('login.signInBtn') }}
					</div>
					<router-link to="/register" tag="div" class="text_7">还没有账号?&nbsp;点击立即注册</router-link>
				</div>
				<div class="group_7 flex-col service">
					<div class="group_8 flex-row justify-between">
						<div class="group_3 flex-col"></div>
						<span class="text_8">五行服务</span>
						<div class="group_4 flex-col"></div>
					</div>
					<div class="text-wrapper_2 flex-col" @click="downloads">
						<span class="text_9">下载五行商会APP</span>
					</div>
					<div class="text-wrapper_3 flex-col" @click="showServicePopup = true">
						<span class="text_10">添加客服</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 在线客服弹窗 -->
		<van-dialog v-model="showServicePopup" title="在线客服" :show-cancel-button="false" confirm-button-text="关闭"
			@confirm="showServicePopup = false">
			<div class="qrcode-container">
				<img :src="serviceQrcode" alt="在线客服二维码" class="qrcode-image">
				<p class="qrcode-tip">扫描二维码联系在线客服</p>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import Vue from "vue";
	import Fetch from "../../utils/fetch";
	import {
		Checkbox,
		Popover,
		Dialog
	} from "vant";

	Vue.use(Checkbox).use(Popover).use(Dialog);

	export default {
		name: "Login",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				password: "password",
				serviceQrcode: null, // 在线客服二维码
				showServicePopup: false, // 在线客服弹窗
				show_kefu: false,
				msg_show: true,
				checked: true,
				showPopover: false,
				actions: [{
						text: "中国",
						icon: require("../images/language/zh_cn.png")
					},
					{
						text: "English",
						icon: require("../images/language/en_us.png")
					},
					{
						text: "日本",
						icon: require("../images/language/ja_jp.png")
					},
					{
						text: "Brasil",
						icon: require("../images/language/ko_kr.png")
					},
					{
						text: "Việt Nam",
						icon: require("../images/language/vi_vn.png")
					},
					{
						text: "Malaysia",
						icon: require("../images/language/th_th.png")
					},
					{
						text: "ประเทศไทย",
						icon: require("../images/language/ms_my.png")
					},
					{
						text: "Indonesia",
						icon: require("../images/language/zh_hk.png")
					},
				],
				lan_num: "中国",
				lan_ico: require("../images/language/zh_cn.png"),
				data: {
					username: "",
					password: "",
				},
				show_ver: false,
			};
		},
		created() {
			this.data.username = localStorage.getItem("login_username");
			this.data.password = localStorage.getItem("login_password");
			this.$parent.footer("user", false);
		},
		mounted() {
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			this.systemInfo();
		},
		methods: {
			systemInfo() {
				Fetch('/user/system_info').then((r) => {
					this.serviceQrcode = r.data.service_img;
				});
			},
			// kefu_to() {
			// 	Fetch("/user/system_info").then((r) => {
			// 		window.location.href = r.data.service;
			// 		// window.open(r.data.service, '_blank');
			// 	});
			// },
			downloads() {
				this.$router.push("/downloadApp");
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			onSelect(action) {
				console.log(action);
				this.lan_ico = action.icon;
				this.lan_num = action.text;
				let lang;
				if (action.text == "中国") {
					lang = "zh_cn";
				}
				if (action.text == "English") {
					lang = "en_us";
				}
				if (action.text == "日本") {
					lang = "ja_jp";
				}
				if (action.text == "Brasil") {
					lang = "ko_kr";
				}
				if (action.text == "Việt Nam") {
					lang = "vi_vn";
				}
				if (action.text == "Malaysia") {
					lang = "th_th";
				}
				if (action.text == "ประเทศไทย") {
					lang = "ms_my";
				}
				if (action.text == "Indonesia") {
					lang = "zh_hk";
				}
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
			},
			submit() {
				if (!this.data.username) {
					this.$toast({
						className: "toastName",
						message: this.$t("login.phoneEmpty"),
					});
					return;
				}

				if (!this.data.password) {
					this.$toast({
						className: "toastName",
						message: this.$t("login.passwordEmpty"),
					});
					return;
				}

				// var regex = /^[A-Za-z0-9]{1,20}$/;
				// if (!regex.test(this.data.username)) {
				//     this.$toast(this.$t('login.phoneError'));
				//     return;
				// }

				if (this.checked) {
					localStorage.setItem("login_username", this.data.username);
					localStorage.setItem("login_password", this.data.password);
				}

				if (!this.checked) {
					localStorage.removeItem("login_username");
					localStorage.removeItem("login_password");
				}

				Fetch("/index/login", {
						username: this.data.username,
						password: this.data.password,
					})
					.then((res) => {
						if (res.data.token) {
							localStorage.setItem("token", res.data.token);
						}
						this.$toast({
							className: "toastName",
							message: this.$t("login.signInSuccess"),
						});
					})
					.then(() => {
						this.$router.replace({
							path: this.$router.history.current.query.redirect || "/",
						});
					});
			},
		},
	};
</script>

<style lang="less" scoped>
	/* rem values halved (px/37.5/2) */

	.page {
		position: relative;
		width: 10rem;
		height: 100vh;
		overflow: hidden;
	}

	.box_1 {
		height: 100vh;
		background: url(~@/assets/login_bg.png) 100% no-repeat;
		background-size: 100% 100%;
		width: 10rem;
	}

	.label_1 {
		width: 0.43rem;
		height: 0.45rem;
		margin: .8rem .4rem 0 0;
	}

	.block_2 {
		width: 8.67rem;
		height: 9rem;
		background: #FFFFFF;
		box-shadow: 0rem 0rem 0rem 0rem rgba(117, 117, 117, 0.2);
		border-radius: 0.31rem;
		// margin: 2.8rem 0 0 0.665rem;
		position: absolute;
		top: 45%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.service {
		position: absolute;
		top: 80%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 80%;
	}

	.text_1 {
		color: rgba(148, 28, 26, 1);
		font-size: 0.93rem;
		font-family: SourceHanSansCN-Bold;
		font-weight: 700;
		text-align: center;
		padding: 0.5rem 0 .7rem 0;
	}

	.text-wrapper_1 {
		background: #f7f7f7;
		width: 7.87rem;
		height: 1.2rem;
		background: #F7F7F7;
		border-radius: 0.6rem;
		margin: 0 0 .4rem 0.4rem;
	}

	.text_2 {
		width: 7.87rem;
		height: 1.2rem;
		color: #333;
		font-size: 0.43rem;
		font-family: SourceHanSansCN-Regular;
		font-weight: 400;
		text-align: left;
		padding: 0 .55rem;
	}

	.section_1 {
		background: #f7f7f7;
		width: 7.87rem;
		height: 1.2rem;
		background: #F7F7F7;
		border-radius: 0.6rem;
		margin: 0 0 .56rem 0.4rem;
		align-items: center;
	}

	.text_3 {
		width: 6.9rem;
		height: 1.2rem;
		color: #333;
		font-size: 0.43rem;
		font-family: SourceHanSansCN-Regular;
		font-weight: 400;
		text-align: left;
		padding: 0 .55rem;
	}

	.item_reset_pwd {
		font-size: 0.37rem;
		line-height: 0.36rem;
		padding: 0 .4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	/deep/ .van-checkbox__icon--checked .van-icon {
		color: #fff;
		background-color: #FFB13A;
		border-color: #FFB13A;
	}

	/deep/ .van-checkbox__label {
		color: #999999;
		font-size: 0.37rem;
	}

	.reset_pwd {
		color: #999999;
		display: block;
		font-size: 0.37rem;
	}

	.basic_btn {
		margin: .65rem .4rem .43rem .4rem;
		width: 7.87rem;
		height: 1.2rem;
		line-height: 1.2rem;
		background: linear-gradient(269deg, #FDB44B, #FCE28B);
		border-radius: 0.6rem;
		color: #222222;
		font-family: SourceHanSansCN;
		font-weight: 400;
		font-size: 0.45rem;
	}

	.text_7 {
		height: 0.43rem;
		font-family: SourceHanSansCN;
		font-weight: 400;
		font-size: 0.45rem;
		color: #FFB13A;
		text-align: center;
	}

	.group_7 {
		margin-bottom: 0.01rem;
	}

	.group_8 {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: .47rem 0 .4rem 0;
	}

	.group_3 {
		width: 2.45rem;
		height: 0.01rem;
		background: #F1F1F1;
	}

	.text_8 {
		font-family: SourceHanSansCN;
		font-weight: 500;
		font-size: 0.47rem;
		color: #FFFFFF;
		line-height: 0.93rem;
		letter-spacing: .02rem;
		margin: 0 .4rem;
	}

	.group_4 {
		width: 2.45rem;
		height: 0.01rem;
		background: #F1F1F1;
	}

	.text-wrapper_2 {
		width: 4.5rem;
		height: 0.8rem;
		background: #FFFFFF;
		border-radius: 0.38rem;
		border: 0px solid #6F6F6F;
		opacity: 0.8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
		margin-bottom: .27rem;
	}

	.text_9 {
		font-family: SourceHanSansCN;
		font-weight: 500;
		font-size: 0.42rem;
		color: #7C090C;
		line-height: 1.48rem;
	}

	.text-wrapper_3 {
		width: 4.5rem;
		height: 0.8rem;
		background: #FFFFFF;
		border-radius: 0.38rem;
		border: 0px solid #6F6F6F;
		opacity: 0.8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
		margin-bottom: .27rem;
	}

	.text_10 {
		font-family: SourceHanSansCN;
		font-weight: 500;
		font-size: 0.42rem;
		color: #7C090C;
		line-height: 1.48rem;
	}

	.qrcode-container {
		padding: 4.26667vw;
		text-align: center;

		.qrcode-image {
			width: 53.33333vw;
			height: auto;
			margin-bottom: 4.26667vw;
		}

		.qrcode-tip {
			font-size: 3.73333vw;
			color: #666;
			margin: 0;
		}
	}
</style>